var OrganizationNamecards, namecard_item;

import NamecardModal from './namecard_modal.js';

import UserOrganizationsContainer from 'trunks/vue/admin/components/organizations/users_organizations_container.js';

import OrganizationsTab from 'trunks/vue/admin/components/organizations/organization_tab.js';

import NamecardItemMixins from './mixins.js';

import OrganizationState from 'trunks/vue/admin/components/organizations/organization_state.js';

namecard_item = {
  mixins: [NamecardItemMixins],
  props: {
    namecard: {
      type: Object
    },
    resources: {
      type: String
    }
  },
  template: `<div class="namecard-wrapper">
  <div class="namecard-item">
    <div class="namecard-img" :style="picture">
    </div>
    <div class="namecard-info">
      <div class="namecard-name">{{namecard.name}}</div>
      <div class="namecard-handle">
        <i class="slp-trash" @click.stop="deleteNamecard"></i>
        <i class="slp-pencil-square" @click.stop="editNamecard"></i>
      </div>
    </div>
  </div>
</div>`
};

export default OrganizationNamecards = Vue.extend({
  components: {
    'namecard-item': namecard_item,
    'user-organization-container': UserOrganizationsContainer,
    'organization-tab': OrganizationsTab
  },
  props: {
    organization: {
      type: Object
    },
    organizationApplicationsCount: {
      type: Number
    },
    namecards_count: {
      type: Number
    }
  },
  data: function() {
    return {
      url: `/admin/organizations/${this.organization.id}/namecards`,
      namecards: [],
      namecardsCount: this.namecards_count,
      organizationState: OrganizationState
    };
  },
  template: `<user-organization-container :title="organization.name">
  <template slot="content">
    <organization-tab :organizationId='organization.id'
                      :pendingOrganizationApplicationsCount='organizationApplicationsCount'
                      activeTab="namecards" />
    <div class="organization-namecard">
      <div class="namecard-add">
        <span class="btn btn-primary" @click.stop="addNamecard">新增</span>
        <span class="helper-text">共{{namecardsCount}}条数据</span>
      </div>
      <div class="namecards-list">
        <div class="namecards-list-wrapper">
          <namecard-item v-for='namecard in namecards'
                        :key='namecard.id'
                        :namecard='namecard'
                        :resources="url"
                        @namecardDeleted="namecardDeleted"
                        @namecardChanged="namecardChanged"/>
        </div>
      </div>
    </div>
  </template>
</user-organization-container>`,
  created: function() {
    return this._initNamecards();
  },
  watch: {
    'organizationState.name': function() {
      return this.organization.name = this.organizationState.name;
    }
  },
  methods: {
    addNamecard: function() {
      return new NamecardModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('add-namecard'),
        propsData: {
          resources: this.url,
          namecardCallback: (data) => {
            return this.namecardChanged(data);
          }
        }
      });
    },
    namecardDeleted: function(namecard) {
      var index;
      index = _.indexOf(this.namecards, namecard);
      this.namecards.splice(index, 1);
      return this.namecardsCount -= 1;
    },
    namecardChanged: function(data) {
      if (data.type === 'new') {
        this.namecardsCount += 1;
        return this.namecards.unshift(data.data);
      } else {
        return this.namecards = _.map(this.namecards, function(item) {
          if (item.id === data.data.id) {
            item = data.data;
          }
          return item;
        });
      }
    },
    _initNamecards: function() {
      return Skylark.Libs.Ajax.get(`${this.url}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: (res) => {
          this.namecards = res;
          return this.namecardsCount = res.length;
        }
      });
    }
  }
});
